import { Injectable } from '@angular/core';
import * as ExcelJS from 'exceljs';
import { ExcelExportConfig } from '../components/common/excel-export-config';

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {

  constructor() {}

  async exportToExcel(config: ExcelExportConfig) {
    const { data, columns, fileName, styles } = config;
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    // Define columns with headers based on the provided column names and set widths
    worksheet.columns = columns.map(col => ({ header: col.header, key: col.key, width: col.width }));

    // Add data to the worksheet
    data.forEach(row => {
      const rowData: { [key: string]: any } = {};
      columns.forEach(col => {
        rowData[col.key] = row[col.key];
      });
      worksheet.addRow(rowData);
    });

    // Apply styles to the header row
    const headerRow = worksheet.getRow(1);
    headerRow.eachCell((cell) => {
      cell.style = styles.header;
    });

    // Apply default styles to all other cells
    worksheet.eachRow((row, rowNumber) => {
      if (rowNumber !== 1) {  // Skip the header row
        row.eachCell((cell) => {
          cell.style = styles.default;
        });
      }
    });

    // Write the Excel file to buffer
    const buffer = await workbook.xlsx.writeBuffer();

    // Create a download link and trigger download
    const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(url);
  }
}
